<template>
  <div class="exchange-admin-page">
    <a-card title="积分兑换履约">
      <div class="toolbar">
        <a-input class="keyword-input" v-model="query.exchangeNo" placeholder="兑换单号" allow-clear />
        <a-input class="keyword-input" v-model="query.customerName" placeholder="客户名称" allow-clear />
        <a-select v-model="query.status" placeholder="状态" allow-clear>
          <a-select-option v-for="item in statuses" :key="item" :value="item">{{ item }}</a-select-option>
        </a-select>
        <a-button type="primary" @click="loadData">查询</a-button>
      </div>
      <a-table row-key="id" :loading="loading" :columns="columns" :data-source="rows"
        :pagination="pagination" @change="changePage">
        <template slot="status" slot-scope="text"><a-tag :color="statusColor(text)">{{ text }}</a-tag></template>
        <template slot="action" slot-scope="text, record">
          <a @click="openDetail(record)">详情</a>
          <template v-if="canDeliverVirtual(record)"><a-divider type="vertical" /><a @click="openVirtual(record)">{{ record.virtualDeliveryText || deliveryImages(record).length ? '修改虚拟产品信息' : '填写虚拟产品信息' }}</a></template>
          <a-divider v-if="record.status === '待发货'" type="vertical" />
          <a v-if="record.status === '待发货' && record.giftCategory === '实物'" @click="openShip(record)">发货</a>
          <a-divider v-if="record.status === '待发货' && record.giftCategory === '实物'" type="vertical" />
          <a v-if="record.status === '待发货'" @click="closeRecord(record)">关闭并退积分</a>
        </template>
      </a-table>
    </a-card>

    <a-modal v-model="shipVisible" title="兑换礼品发货" @ok="submitShip">
      <a-form-model :model="shipForm" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
        <a-form-model-item label="快递公司"><a-input v-model.trim="shipForm.expressCompany" /></a-form-model-item>
        <a-form-model-item label="快递单号"><a-input v-model.trim="shipForm.expressNo" /></a-form-model-item>
      </a-form-model>
    </a-modal>

    <a-modal v-model="detailVisible" title="兑换记录详情" :footer="null" width="720px">
      <a-descriptions v-if="detailRecord" bordered :column="2" size="small">
        <a-descriptions-item label="兑换单号">{{ detailRecord.exchangeNo || '--' }}</a-descriptions-item>
        <a-descriptions-item label="状态"><a-tag :color="statusColor(detailRecord.status)">{{ detailRecord.status || '--' }}</a-tag></a-descriptions-item>
        <a-descriptions-item label="礼品名称">{{ detailRecord.giftName || '--' }}</a-descriptions-item>
        <a-descriptions-item label="礼品分类">{{ detailRecord.giftCategory || '--' }}</a-descriptions-item>
        <a-descriptions-item label="客户名称">{{ detailRecord.customerName || '--' }}</a-descriptions-item>
        <a-descriptions-item label="消耗积分">{{ detailRecord.pointsAmount || 0 }}</a-descriptions-item>
        <a-descriptions-item label="收货人">{{ detailRecord.receiverName || '--' }}</a-descriptions-item>
        <a-descriptions-item label="联系电话">{{ detailRecord.receiverPhone || '--' }}</a-descriptions-item>
        <a-descriptions-item label="收货地址" :span="2">{{ detailRecord.receiverAddress || '--' }}</a-descriptions-item>
        <a-descriptions-item label="快递公司">{{ detailRecord.expressCompany || '--' }}</a-descriptions-item>
        <a-descriptions-item label="快递单号">{{ detailRecord.expressNo || '--' }}</a-descriptions-item>
        <a-descriptions-item label="创建时间">{{ detailRecord.createdAt || '--' }}</a-descriptions-item>
        <a-descriptions-item label="更新时间">{{ detailRecord.updatedAt || '--' }}</a-descriptions-item>
      </a-descriptions>
      <div v-if="detailRecord && (detailRecord.virtualDeliveryText || deliveryImages(detailRecord).length)" class="virtual-content">
        <h3>虚拟产品信息</h3>
        <p class="delivery-text">{{ detailRecord.virtualDeliveryText }}</p>
        <img v-for="image in deliveryImages(detailRecord)" :key="image" :src="assetPath(image)" alt="虚拟产品图片">
      </div>
    </a-modal>

    <a-modal v-model="virtualVisible" title="虚拟产品信息" :width="720" :confirm-loading="virtualSaving"
      :closable="!virtualSaving" :mask-closable="!virtualSaving" :cancel-button-props="{ props: { disabled: virtualSaving } }" @ok="submitVirtual">
      <a-form-model :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
        <a-form-model-item label="兑换单号">{{ activeRecord && activeRecord.exchangeNo }}</a-form-model-item>
        <a-form-model-item label="文字"><a-textarea v-model="virtualText" :rows="6" :max-length="5000" placeholder="填写兑换码、使用方法等信息" :disabled="virtualSaving" /></a-form-model-item>
        <a-form-model-item label="图片">
          <a-upload name="file" list-type="picture-card" :file-list="virtualFiles" :action="uploadAction" :headers="uploadHeaders"
            accept=".jpg,.jpeg,.png,.webp,.gif,.bmp" :before-upload="beforeVirtualUpload" :disabled="virtualSaving" @change="handleVirtualUpload">
            <a-button v-if="virtualFiles.length < 6" icon="upload">上传图片</a-button>
          </a-upload>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { getPointsExchangeList, shipPointsExchange, closePointsExchange, deliverPointsVirtual, API_BASE_URL } from '@/api'
import adminSession from '@/utils/adminSession'
import commerce from '@/utils/pcCommerce'

export default {
  data() {
    return {
      loading: false,
      rows: [],
      query: {},
      statuses: ['待发货', '待收货', '已完成', '已关闭'],
      shipVisible: false,
      virtualVisible: false,
      virtualSaving: false,
      virtualText: '',
      virtualFiles: [],
      uploadAction: API_BASE_URL + '/upload/image',
      detailVisible: false,
      detailRecord: null,
      activeRecord: null,
      shipForm: { expressCompany: '', expressNo: '' },
      pagination: { current: 1, pageSize: 10, total: 0 },
      columns: [
        { title: '兑换单号', dataIndex: 'exchangeNo' },
        { title: '礼品', dataIndex: 'giftName' },
        { title: '分类', dataIndex: 'giftCategory' },
        { title: '客户', dataIndex: 'customerName' },
        { title: '消耗积分', dataIndex: 'pointsAmount' },
        { title: '快递公司', dataIndex: 'expressCompany' },
        { title: '快递单号', dataIndex: 'expressNo' },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' } },
        { title: '操作', key: 'action', width: 290, scopedSlots: { customRender: 'action' } }
      ]
    }
  },
  computed: {
    uploadHeaders() { return { Authorization: 'Bearer ' + adminSession.getAdminToken() } }
  },
  created() { this.loadData() },
  methods: {
    assetPath: commerce.normalizeAssetPath,
    deliveryImages(record) {
      try { const images = JSON.parse(record.virtualDeliveryImages || '[]'); return Array.isArray(images) ? images : [] } catch (error) { return [] }
    },
    canDeliverVirtual(record) { return record.giftCategory !== '实物' && ['待发货', '已完成'].includes(record.status) },
    openVirtual(record) {
      this.activeRecord = record
      this.virtualText = record.virtualDeliveryText || ''
      this.virtualFiles = this.deliveryImages(record).map((path, index) => ({ uid: 'stored-' + index, name: '图片' + (index + 1), status: 'done', url: this.assetPath(path), storedPath: path }))
      this.virtualVisible = true
    },
    beforeVirtualUpload(file) {
      if (this.virtualFiles.length >= 6) { this.$message.warning('最多上传6张图片'); return false }
      if (!/\.(jpg|jpeg|png|webp|gif|bmp)$/i.test(file.name) || !file.type.startsWith('image/')) { this.$message.warning('请选择 JPG、PNG、WEBP、GIF 或 BMP 图片'); return false }
      if (file.size > 5 * 1024 * 1024) { this.$message.warning('每张图片不能超过5MB'); return false }
      return true
    },
    handleVirtualUpload(info) {
      this.virtualFiles = info.fileList.map(file => {
        if (!file.response) return file
        if (file.response.code !== 200) return { ...file, status: 'error' }
        const path = file.response.data && file.response.data.path
        return path ? { ...file, storedPath: path, url: this.assetPath(path) } : { ...file, status: 'error' }
      })
      if (info.file.status === 'done' && (!info.file.response || info.file.response.code !== 200)) this.$message.error((info.file.response && info.file.response.msg) || '图片上传失败')
    },
    async submitVirtual() {
      if (this.virtualSaving) return
      if (this.virtualFiles.some(file => file.status !== 'done' || !file.storedPath)) return this.$message.warning('请等待图片上传完成，或移除上传失败的图片')
      if (!this.virtualText.trim() && !this.virtualFiles.length) return this.$message.warning('请填写文字或上传图片')
      this.virtualSaving = true
      try {
        const response = await deliverPointsVirtual(this.activeRecord.id, { text: this.virtualText.trim(), images: this.virtualFiles.map(file => file.storedPath) })
        if (this.detailRecord && this.detailRecord.id === this.activeRecord.id) this.detailRecord = response.data
        this.virtualVisible = false
        this.$message.success('虚拟产品信息已保存')
        this.loadData()
      } finally { this.virtualSaving = false }
    },
    statusColor(status) {
      return { 待发货: 'orange', 待收货: 'blue', 已完成: 'green', 已关闭: 'default' }[status] || 'default'
    },
    openDetail(record) {
      this.detailRecord = record
      this.detailVisible = true
    },
    loadData() {
      this.loading = true
      getPointsExchangeList({ ...this.query, page: this.pagination.current, pageSize: this.pagination.pageSize })
        .then(res => {
          const data = res.data || {}
          this.rows = data.records || []
          this.pagination.total = data.total || 0
        }).finally(() => { this.loading = false })
    },
    changePage(page) {
      this.pagination.current = page.current
      this.pagination.pageSize = page.pageSize
      this.loadData()
    },
    openShip(record) {
      this.activeRecord = record
      this.shipForm = { expressCompany: record.expressCompany || '', expressNo: record.expressNo || '' }
      this.shipVisible = true
    },
    submitShip() {
      if (!this.shipForm.expressCompany || !this.shipForm.expressNo) return this.$message.warning('请填写快递公司和快递单号')
      shipPointsExchange(this.activeRecord.id, this.shipForm).then(() => {
        this.$message.success('兑换礼品已发货')
        this.shipVisible = false
        this.loadData()
      })
    },
    closeRecord(record) {
      const reason = window.prompt('请输入关闭原因，关闭后将退回积分并恢复礼品库存')
      if (!reason) return
      this.$confirm({
        title: '确认关闭兑换单？',
        content: '该操作会退回积分并恢复礼品库存。',
        onOk: () => closePointsExchange(record.id, { reason }).then(() => {
          this.$message.success('兑换单已关闭，积分和库存已退回')
          this.loadData()
        })
      })
    }
  }
}
</script>

<style scoped>
.exchange-admin-page { padding: 20px; }
.toolbar { margin-bottom: 16px; display: flex; gap: 10px; }
.toolbar .keyword-input { width: 140px; }
.toolbar .ant-select { width: 150px; }
.virtual-content { margin-top: 20px; }
.delivery-text { white-space: pre-wrap; overflow-wrap: anywhere; }
.virtual-content img { display: block; max-width: 100%; height: auto; margin-top: 12px; }
</style>
